module.exports = __webpack_public_path__ + "img/osakana_banner.5bb7914d.jpg";